import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator";
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator";


export class Cmsmf {
    //@MaxLength(10,{message: 'COMPANY 字串太長'})
    //@IsString({message: 'COMPANY 不是字串型態'})
    COMPANY: string = '';

    //@MaxLength(10)
    CREATOR: string = '';

    //@MaxLength(10)
    USR_GROUP: string = '';

    //@MaxLength(8)
    CREATE_DATE: string ='';

    //@MaxLength(10)
    MODIFIER: string = '';

    //@MaxLength(8)
    MODI_DATE: string = '';

    //@IsNumber()
    //@Max(999)
    FLAG: number =0;


    //@IsNotEmpty({message: '幣別 (MF001) 不可空白'})
    //@MaxLength(4,{message: '幣別 (MF001) 資料太長'})
    MF001: string = '';            // 幣別 4 幣別

    //@MaxLength(10,{message: '幣別名稱 (MF002) 資料太長'})
    MF002: string = '';            // 幣別名稱 10 幣別名稱

    //@MaxLength(1,{message: '單價取位 (MF003) 資料太長'})
    MF003: string = '';            // 單價取位 1 0.整數、1.小數一位、2.小數二位、3.小數三位、4.小數四位、5.小數五位、6.小數六位//900828 3.1 S06-9006006 ADD

    //@MaxLength(1,{message: '金額取位 (MF004) 資料太長'})
    MF004: string = '';            // 金額取位 1 0.整數、1.小數一位、2.小數二位

    //@MaxLength(1,{message: '單位成本取位 (MF005) 資料太長'})
    MF005: string = '';            // 單位成本取位 1 0.整數、1.小數一位、2.小數二位、3.小數三位、4.小數四位、5.小數五位、6.小數六位//900828 3.1 S06-9006006 ADD

    //@MaxLength(1,{message: '成本金額取位 (MF006) 資料太長'})
    MF006: string = '';            // 成本金額取位 1 0.整數、1.小數一位、2.小數二位

    //@MaxLength(255,{message: '備註 (MF007) 資料太長'})
    MF007: string = '';            // 備註 255 備註

    //@MaxLength(4,{message: '電子發票幣別對照 (MF300) 資料太長'})
    MF300: string = '';            // 電子發票幣別對照 4 電子發票幣別對照


}
